import React, { lazy } from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  return <section className="py-[50px] px-[15px] relative bg-gradient-to-br from-[#991B1B] to-[#111827]" data-id="element-177">
      <div className="container max-w-full mx-auto px-[15px] relative z-[2]" data-id="element-178">
        <div className="bg-gradient-to-r from-[#DC2626] to-[#991B1B] text-white p-[12px_20px] text-center font-[700] text-[18px] uppercase rounded-[8px] mb-[25px] shadow-[0_5px_15px_rgba(220,38,38,0.3)] w-full" data-id="element-179">
          There's a moment you don't talk about.
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#DC2626] bg-[rgba(255,255,255,0.95)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-180">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-181" />
          <div data-id="element-182">
            It's not the pain. It's the hesitation—right before the step. The
            curb. The stairs. The parking lot.{' '}
            <strong data-id="element-183">The split-second thought: "What if it gives out?"</strong>
          </div>
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#DC2626] bg-[rgba(255,255,255,0.95)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-184">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-185" />
          <div data-id="element-186">
            And that's how life gets smaller. Quietly. Not because you "can't."{' '}
            <strong data-id="element-187">Because your knee feels unpredictable.</strong>
          </div>
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#DC2626] bg-[rgba(255,255,255,0.95)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-188">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-189" />
          <div data-id="element-190">
            Stiff when you first stand up. Wobbly at random moments. Fine one
            day and "nope" the next.{' '}
            <strong data-id="element-191">You're not crazy. You're not lazy.</strong>
          </div>
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#DC2626] bg-[rgba(255,255,255,0.95)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-192">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-193" />
          <div data-id="element-194">
            You're not failing at willpower.{' '}
            <strong data-id="element-195">You're dealing with a geometry problem.</strong>
          </div>
        </div>
      </div>
    </section>;
}